import { useCallback } from 'react'
import { requests } from '../../../core/ajax'

export const useStuckCalls = () => {
  const { get } = requests

  const getStuck = useCallback(
    (config) =>
      new Promise((resolve, reject) => {
        get('/solicitudes/tabla_encalladas_v3', config)
          .then((response) => {
            return resolve(response)
          })
          .catch(({ response }) => {
            return reject(response)
          })
      }),
    [] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return {
    getStuck,
  }
}
